"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    top: 100%;\n    right: auto;\n    bottom: auto;\n    border: 0 none;\n    z-index: 2;\n    border-width: 12px;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: ", ";\n    border-style: solid;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HintTriangle = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.palette.elBlack;
});

var _default = HintTriangle;
exports["default"] = _default;